export default __webpack_public_path__ + "static/media/tractor_usage_report_icon.0e6dac03.svg";